<template>
  <standard-layout>
    <template #header>
      <navigation-bar ref="header" />
    </template>
    <!-- Using Named Slots Shorthand cannot be reactive -->
    <!-- Check: https://github.com/vuejs/vue/issues/10330 -->
    <template slot="sidebar">
      <management-sidebar
        v-if="isLoggedIn && isInManagement"
        :style="{'margin-top': headerHeight + 'px'}"
      />
      <settings-sidebar
        v-if="isLoggedIn && isInSettings"
        :style="{'margin-top': headerHeight + 'px'}"
      />
    </template>
    <router-view
      v-if="isReady"
      :style="{'margin-top': headerHeight + 'px'}"
    />
  </standard-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import router from '@/router'
import store from './store'

import NavigationBar from './components/NavigationBar.vue'
import ManagementSidebar from './components/ManagementSidebar.vue'
import SettingsSidebar from './components/SettingsSidebar.vue'

export default {
  name: 'App',
  components: {
    NavigationBar,
    ManagementSidebar,
    SettingsSidebar
  },

  props: {},

  data () {
    return {
      headerHeight: 0
    }
  },

  computed: {
    ...mapState('client', [
      'authClient'
    ]),
    ...mapGetters('client', [
      'isReady'
    ]),
    ...mapGetters('currentUser', [
      'isLoggedIn'
    ]),
    ...mapState('currentUser/permissions', [
      'permissions'
    ]),
    isInManagement () {
      return this.$route.path.startsWith('/management') // current path includes with this path string
    },
    isInSettings () {
      return this.$route.path.startsWith('/settings')
    }
  },

  watch: {
    isLoggedIn (newVal) {
      if (newVal) {
        // Falsy accessToken return from the function
        if (!this.authClient.getAccessToken()) return
        store.dispatch('currentUser/permissions/list')
      } else {
        store.commit('currentUser/permissions/CLEAR_STATES')
        store.commit('currentUser/CLEAR_STATES')
      }
    }
  },

  created () {
    this.init()
  },
  mounted () {
    this.headerHeight = this.$refs.header.$el.clientHeight
  },
  updated () {},
  destroyed () {},

  methods: {
    async init () {
      const accessToken = localStorage.getItem('io.authcore.accessToken')
      await store.dispatch('client/init', accessToken)
      // Falsy accessToken return from the function
      if (this.authClient.getAccessToken()) {
        await Promise.all([
          store.dispatch('currentUser/get'),
          store.dispatch('currentUser/permissions/list')
        ])
        store.commit('client/SET_AUTHENTICATED_STATE', true)
      }
      store.commit('management/SET_READY_STATE', true)
    },
    setCurrentUserCallback (user) {
      store.commit('currentUser/GET_CURRENT_USER_COMPLETED', user)
    }
  }
}

// Router setting
router.beforeEach((to, from, next) => {
  if (to.meta.title !== undefined) {
    document.title = to.meta.title + ' - Authcore Management'
  } else {
    document.title = 'Authcore Management'
  }
  next()
})
</script>
